import React from 'react';
import { Navigate } from 'react-router-dom';

// Build-time strip target. In the production bundle the Knowledge Controls
// and EBTA page modules are replaced by this stub (craco.config.js), so their
// real code is physically absent from the served JavaScript. Any visit to a
// stripped route redirects to the main page.
export default function StrippedSurface() {
  return <Navigate to="/" replace />;
}
